export default __webpack_public_path__ + "static/media/film.7fb7c8f6.png";